import { callAPI } from "../../network/networkConnection";

const BASE_URL = process.env.REACT_APP_APIUrl + "supplier-address";

// Get all addresses
const getAllAddresses = (source = "") => {
  const query = source ? `?source=${source}` : "";
  return callAPI(`${BASE_URL}${query}`, "GET", { "Content-Type": "application/json" });
};

// Get warehouse addresses only
const getWarehouseAddresses = () => {
  return callAPI(`${BASE_URL}/warehouses`, "GET", { "Content-Type": "application/json" });
};

// Get addresses linked to a specific warehouse
const getAddressesByWarehouse = (warehouseId) => {
  return callAPI(`${BASE_URL}/warehouse/${warehouseId}/addresses`, "GET", { "Content-Type": "application/json" });
};

// Get default address by source
const getDefaultAddress = (source = "alibaba") => {
  return callAPI(`${BASE_URL}/default?source=${source}`, "GET", { "Content-Type": "application/json" });
};

// Get address by ID
const getAddressById = (id) => {
  return callAPI(`${BASE_URL}/${id}`, "GET", { "Content-Type": "application/json" });
};

// Create new address
const createAddress = (addressData) => {
  return callAPI(`${BASE_URL}`, "POST", { "Content-Type": "application/json" }, JSON.stringify(addressData));
};

// Create address linked to a warehouse
const createWarehouseAddress = (warehouseId, addressData) => {
  return callAPI(
    `${BASE_URL}/warehouse/${warehouseId}/addresses`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(addressData)
  );
};

// Update address
const updateAddress = (id, addressData) => {
  return callAPI(`${BASE_URL}/${id}`, "PUT", { "Content-Type": "application/json" }, JSON.stringify(addressData));
};

// Set default address
const setDefaultAddress = (id) => {
  return callAPI(`${BASE_URL}/${id}/set-default`, "PUT", { "Content-Type": "application/json" });
};

// Delete address
const deleteAddress = (id) => {
  return callAPI(`${BASE_URL}/${id}`, "DELETE", { "Content-Type": "application/json" });
};

// Get next sequences for a warehouse (preview only - does NOT increment counter)
const getNextSequences = (warehouseId, prefix, count, pattern = "YK", digits = 4) => {
  return callAPI(
    `${BASE_URL}/sequences`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify({ warehouseId, prefix, count, pattern, digits })
  );
};

// Commit sequences after successful order creation (increments counter)
const commitSequences = (warehouseId, count) => {
  return callAPI(
    `${BASE_URL}/sequences/commit`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify({ warehouseId, count })
  );
};

// Get sequence info for a warehouse
const getSequenceInfo = (warehouseId) => {
  return callAPI(`${BASE_URL}/sequence/${warehouseId}`, "GET", { "Content-Type": "application/json" });
};

// Update warehouse prefix settings
const updateWarehousePrefix = (id, prefixData) => {
  return callAPI(
    `${BASE_URL}/${id}/prefix`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(prefixData)
  );
};

export const supplierAddressService = {
  getAllAddresses,
  getWarehouseAddresses,
  getAddressesByWarehouse,
  getDefaultAddress,
  getAddressById,
  createAddress,
  createWarehouseAddress,
  updateAddress,
  setDefaultAddress,
  deleteAddress,
  getNextSequences,
  commitSequences,
  getSequenceInfo,
  updateWarehousePrefix,
};
